interface LinkAppConfig {
  ENVIRONMENT: "Local" | "Integration" | "Production";
  PORTAL_URL: string;
  LINK_API_URL: string;
  LINK_SDK_URL: string;
  PUBLIC_API_URL: string;
  GA_TRACKING_ID: string;
  AMPLITUDE_API_KEY: string;
}

interface ConfigWindow extends Window {
  linkAppConfig: LinkAppConfig;
}

declare let window: ConfigWindow;

const config: LinkAppConfig = window.linkAppConfig || {
  ENVIRONMENT: "Integration",
  PORTAL_URL: "https://app-integration.codat.io",
  LINK_API_URL: "https://link-api-integration.codat.io",
  LINK_SDK_URL: "https://link-sdk-integration.codat.io",
  PUBLIC_API_URL: "https://api-integration.codat.io",
  GA_TRACKING_ID: "",
  AMPLITUDE_API_KEY: "1c2a84301c15f56221a6f81af617f5f7",
};

export default config;
